import { defineStore } from 'pinia'

const useAtendimentoStore = defineStore('atendimento', {
  state: () => ({
    isLoading: false,
    ticketSelecionadoId: 0,
    ticketSelecionadoFoiAlterado: false,
  }),

  actions: {
    setIsLoading(v) {
      this.isLoading = v
    },
    setTicketSelecionadoId(id) {
      this.ticketSelecionadoId = id
    },
    setTicketSelecionadoFoiAlterado(v) {
      this.ticketSelecionadoFoiAlterado = v
    },
  },
})

export default useAtendimentoStore
